<template>
  <div class="countup">
    <div class="countup-digit">{{ minutes | two_digits }}</div>
    <span class="divider">:</span>
    <div class="countup-digit">{{ seconds | two_digits }}</div>
  </div>
</template>

<script>
export default {
  name: 'Countup',

  props: {
    start: {
      type: [String, Date],
      default: new Date()
    }
  },

  data() {
    return {
      now: Math.trunc(new Date().getTime() / 1000)
    };
  },

  computed: {
    startInMilliseconds() {
      return Math.trunc(new Date(this.start).getTime() / 1000);
    },

    seconds() {
      return (this.now - this.startInMilliseconds) % 60;
    },

    minutes() {
      return Math.trunc((this.now - this.startInMilliseconds) / 60) % 60;
    }
  },

  created() {
    const interval = setInterval(() => {
      this.now = Math.trunc(new Date().getTime() / 1000);
    }, 1000);

    this.$once('hook:beforeDestroy', () => {
      clearInterval(interval);
    });
  }
};
</script>

<style lang="less">
.countup {
  display: flex;
  align-items: center;

  .divider {
    margin: 0 2px 0 3px;
  }
}

.countup-digit {
  width: 35px;
}
</style>
